var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container",style:(`height: ${_vm.height}px`)},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }